import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XMarkIcon, EnvelopeIcon, UserIcon } from '@heroicons/react/24/outline';

const AddMemberModal = ({ groupId, onClose, onSubmit }) => {
  const [inputType, setInputType] = useState('email');
  const [email, setEmail] = useState('');
  const [guestName, setGuestName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (inputType === 'email' && email.trim()) {
        await onSubmit({ email: email.trim().toLowerCase() });
      } else if (inputType === 'guest' && guestName.trim()) {
        await onSubmit({ guest_name: guestName.trim() });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AnimatePresence>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/40 z-50 flex items-end sm:items-center justify-center" onClick={onClose}>
        <motion.div initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }}
          transition={{ type: 'spring', damping: 25, stiffness: 200 }}
          className="bg-white rounded-t-[32px] sm:rounded-3xl p-6 w-full max-w-md shadow-[0_-10px_40px_rgba(0,0,0,0.1)]"
          onClick={(e) => e.stopPropagation()}>

          <div className="w-10 h-1 bg-slate-300 rounded-full mx-auto mb-6 sm:hidden"></div>
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-bold text-slate-900">Tambah Member</h3>
            <button onClick={onClose} data-testid="close-add-member-modal"
              className="w-8 h-8 rounded-full bg-surface flex items-center justify-center hover:bg-surface-hover transition-colors">
              <XMarkIcon className="w-5 h-5 text-slate-600" />
            </button>
          </div>

          <div className="flex gap-2 bg-surface p-1 rounded-full mb-6">
            <button type="button" onClick={() => setInputType('email')} data-testid="invite-email-tab"
              className={`flex-1 py-2 px-4 rounded-full font-semibold text-sm transition-all ${inputType === 'email' ? 'bg-primary text-white shadow-sm' : 'text-slate-600'}`}>
              Via Email
            </button>
            <button type="button" onClick={() => setInputType('guest')} data-testid="invite-guest-tab"
              className={`flex-1 py-2 px-4 rounded-full font-semibold text-sm transition-all ${inputType === 'guest' ? 'bg-primary text-white shadow-sm' : 'text-slate-600'}`}>
              Guest Member
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            {inputType === 'email' ? (
              <div>
                <label className="text-sm font-semibold text-slate-600 mb-2 block">Email Member</label>
                <div className="relative">
                  <EnvelopeIcon className="w-5 h-5 text-slate-400 absolute left-4 top-1/2 -translate-y-1/2" />
                  <input type="email" data-testid="member-email-input" value={email}
                    onChange={(e) => setEmail(e.target.value)} placeholder="member@email.com"
                    className="w-full pl-12 pr-4 py-3 rounded-[16px] border border-border focus:outline-none focus:ring-2 focus:ring-primary transition-all" autoFocus />
                </div>
                <p className="text-xs text-slate-500 mt-2">Email harus sudah terdaftar di Patungin. Jika belum, silakan pakai Guest Member.</p>
              </div>
            ) : (
              <div>
                <label className="text-sm font-semibold text-slate-600 mb-2 block">Nama Guest</label>
                <div className="relative">
                  <UserIcon className="w-5 h-5 text-slate-400 absolute left-4 top-1/2 -translate-y-1/2" />
                  <input type="text" data-testid="member-guest-name-input" value={guestName}
                    onChange={(e) => setGuestName(e.target.value)} placeholder="Masukkan nama..."
                    className="w-full pl-12 pr-4 py-3 rounded-[16px] border border-border focus:outline-none focus:ring-2 focus:ring-primary transition-all" autoFocus />
                </div>
                <p className="text-xs text-slate-500 mt-2">Guest member tidak memiliki akun terhubung, hanya nama saja.</p>
              </div>
            )}

            <button type="submit" data-testid="submit-add-member"
              disabled={(inputType === 'email' ? !email.trim() : !guestName.trim()) || loading}
              className="w-full bg-primary text-white py-3 rounded-full font-semibold hover:bg-primary-hover active:scale-95 transition-all shadow-float disabled:opacity-50 disabled:cursor-not-allowed">
              {loading ? 'Menambahkan...' : 'Tambah Member'}
            </button>
          </form>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default AddMemberModal;
